import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/gm',
    children: [
      { path: '', redirect: '/gm/home' },
      { path: 'home', name: 'gm-home', component: () => import('@/modules/gm/GmHome.vue') },
      { path: 'project360/:id?', name: 'gm-project360', component: () => import('@/modules/gm/Project360.vue') },
      { path: 'big-screen', name: 'gm-big-screen', component: () => import('@/modules/gm/BigScreenView.vue'), meta: { layout: 'plain' } }
    ]
  }
]

export default routes
